import { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import logo from '../assets/images/logo.png';

const navigation = [
  { name: 'Home', href: '/' },
  { name: 'About Me', href: '/aboutme' },
  { name: 'Blog', href: '/blog' },
  // { name: 'Resume', href: '/resume' },
  { name: 'Contact', href: '/contact' },
];

export default function NavBar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Detect scroll to add shadow/background
  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 10) setScrolled(true);
      else setScrolled(false);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const linkBase =
    'text-sm font-semibold leading-6 transition-colors hover:text-indigo-600';
  const linkActive = ({ isActive }) =>
    isActive ? `${linkBase} text-indigo-700` : `${linkBase} text-gray-800`;

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 border-b ${
        scrolled
          ? 'bg-white/90 backdrop-blur shadow-sm border-gray-200'
          : 'bg-transparent border-transparent'
      }`}
    >
      <nav
        aria-label="Global"
        className="mx-auto max-w-7xl h-16 flex items-center justify-between px-4 lg:px-8 border-b-1 border-gray-300"
      >
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          <img className="h-8 w-auto" src={logo} alt="Angelo Ruiz" />
          {/* <span className="text-base font-bold">{'{AR}'}</span> */}
        </Link>

        {/* Desktop Nav */}
        <div className="hidden lg:flex lg:gap-x-12">
          {navigation.map((item) => (
            <NavLink key={item.name} to={item.href} className={linkActive}>
              {item.name}
            </NavLink>
          ))}
        </div>

        {/* Mobile Menu Toggle */}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden -m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
          aria-label="Toggle menu"
          aria-expanded={open}
        >
          {open ? <XMarkIcon className="h-6 w-6" /> : <Bars3Icon className="h-6 w-6" />}
        </button>
      </nav>

      {/* Mobile Menu Panel */}
      {open && (
        <div className="lg:hidden border-b border-gray-400 bg-white">
          <div className="mx-auto max-w-7xl px-4 py-3 flex flex-col gap-3">
            {navigation.map((item) => (
              <NavLink
                key={item.name}
                to={item.href}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  isActive
                    ? 'font-semibold text-indigo-700'
                    : 'font-semibold text-gray-800'
                }
              >
                {item.name}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
